import { action } from 'satcheljs';
export var onComposeOpened = action('ON_COMPOSE_OPENED');
export var onComposeClosed = action('ON_COMPOSE_CLOSED');
//# sourceMappingURL=composeActions.js.map